import store from '@/state/store'
import axios from 'axios'
import { authHeader } from '../helpers/auth-header'

export default [
    {
        path: '*',
        name: 'not-found',
        component: () => import('../views/pages/utility/error-404'),
    },
    {
        path: '/login',
        name: 'login',
        component: () => import('../views/pages/account/login'),
        meta: {
            beforeResolve(routeTo, routeFrom, next) {
                // If the user is already logged in
                if (store.getters['auth/loggedIn']) {
                    // Redirect to the home page instead
                    next({ name: 'home' })
                } else {
                    // Continue to the login page
                    next()
                }
            },
        },
    },
    {
        path: '/register',
        name: 'register',
        component: () => import('../views/pages/account/register'),
        meta: {
            beforeResolve(routeTo, routeFrom, next) {
                // If the user is already logged in
                if (store.getters['auth/loggedIn']) {
                    // Redirect to the home page instead
                    next({ name: 'home' })
                } else {
                    // Continue to the login page
                    next()
                }
            },
        },
    },
    {
        path: '/forgot-password',
        name: 'Forgot-password',
        component: () => import('../views/pages/account/forgot-password'),
        meta: {
            beforeResolve(routeTo, routeFrom, next) {
                // If the user is already logged in
                if (store.getters['auth/loggedIn']) {
                    // Redirect to the home page instead
                    next({ name: 'home' })
                } else {
                    // Continue to the login page
                    next()
                }
            },
        },
    },
    {
        path: '/logout',
        name: 'logout',
        meta: {
            authRequired: true,
            async beforeResolve(routeTo, routeFrom, next) {
                try {
                    const userData = localStorage.getItem('user');
                    await axios.post(`${process.env.VUE_APP_APIURL}/admin/logout`, userData, {
                        headers: authHeader(),
                    });
                } catch (err) {
                    console.log(err);
                }

                next('/login');
            },
        },
    },
    {
        path: '/',
        name: 'home',
        meta: {
            authRequired: true,
        },
        component: () => import('../views/pages/dashboard/index'),
        beforeEnter: (to, from, next) => {
            next();
        },
    },
    {
        path: '/profile',
        name: 'profile',
        meta: {
            authRequired: true,
        },
        component: () => import('../views/pages/account/profile')
    },

    // Admin
    {
        path: '/admin',
        name: 'Admin',
        meta: { authRequired: true },
        component: () => import('../views/pages/admin/index'),
        beforeEnter: (to, from, next) => {
            const userData = localStorage.getItem('user');
            const userObject = JSON.parse(userData);
            const userType = userObject.user_type;

            // const staffId = window.sessionStorage.getItem('staff_id');
            if (userType !== 'admin') {
                next({ name: 'Error-404' });
            } else {
                next();
            }
        },
    },
    {
        path: '/admin/form/:id',
        name: 'Admin Form',
        meta: { authRequired: true },
        component: () => import('../views/pages/admin/form'),
        beforeEnter: (to, from, next) => {
            const userData = localStorage.getItem('user');
            const userObject = JSON.parse(userData);
            const userType = userObject.user_type;

            // const staffId = window.sessionStorage.getItem('staff_id');
            if (userType !== 'admin') {
                next({ name: 'Error-404' });
            } else {
                next();
            }
        },
    },
    {
        path: '/admin/form/:id/password',
        name: 'Admin Edit Password',
        meta: { authRequired: true },
        component: () => import('../views/pages/admin/edit_password'),
        beforeEnter: (to, from, next) => {
            const userData = localStorage.getItem('user');
            const userObject = JSON.parse(userData);
            const userType = userObject.user_type;

            // const staffId = window.sessionStorage.getItem('staff_id');
            if (userType !== 'admin') {
                next({ name: 'Error-404' });
            } else {
                next();
            }
        },
    },

    // Staff
    {
        path: '/staff',
        name: 'Staff',
        meta: { authRequired: true },
        component: () => import('../views/pages/staff/index'),
        beforeEnter: (to, from, next) => {
            const userData = localStorage.getItem('user');
            const userObject = JSON.parse(userData);
            const userType = userObject.user_type;

            // const staffId = window.sessionStorage.getItem('staff_id');
            if (userType !== 'admin') {
                next({ name: 'Error-404' });
            } else {
                next();
            }
        },
    },
    {
        path: '/staff/form/:id',
        name: 'Staff Form',
        meta: { authRequired: true },
        component: () => import('../views/pages/staff/form'),
        beforeEnter: (to, from, next) => {
            const userData = localStorage.getItem('user');
            const userObject = JSON.parse(userData);
            const userType = userObject.user_type;

            // const staffId = window.sessionStorage.getItem('staff_id');
            if (userType !== 'admin') {
                next({ name: 'Error-404' });
            } else {
                next();
            }
        },
    },

    // Treatment
    {
        path: '/treatment',
        name: 'Treatment',
        meta: { authRequired: true },
        component: () => import('../views/pages/product/index'),
        beforeEnter: (to, from, next) => {
            const userData = localStorage.getItem('user');
            const userObject = JSON.parse(userData);
            const userType = userObject.user_type;

            // const staffId = window.sessionStorage.getItem('staff_id');
            if (userType !== 'admin') {
                next({ name: 'Error-404' });
            } else {
                next();
            }
        },
    },
    {
        path: '/treatment/form/:id',
        name: 'Treatment Form',
        meta: { authRequired: true },
        component: () => import('../views/pages/product/form'),
        beforeEnter: (to, from, next) => {
            const userData = localStorage.getItem('user');
            const userObject = JSON.parse(userData);
            const userType = userObject.user_type;

            // const staffId = window.sessionStorage.getItem('staff_id');
            if (userType !== 'admin') {
                next({ name: 'Error-404' });
            } else {
                next();
            }
        },
    },

    // Bookings
    {
        path: '/booking',
        name: 'Booking',
        meta: { authRequired: true },
        component: () => import('../views/pages/booking/index')
    },
    {
        path: '/booking/form/:id',
        name: 'Booking Form',
        meta: { authRequired: true },
        component: () => import('../views/pages/booking/form'),
        beforeEnter: (to, from, next) => {
            const userData = localStorage.getItem('user');
            const userObject = JSON.parse(userData);
            const userType = userObject.user_type;

            // const staffId = window.sessionStorage.getItem('staff_id');
            if (userType !== 'admin') {
                next({ name: 'Error-404' });
            } else {
                next();
            }
        },
    },
    {
        path: '/booking-staff/form/:id',
        name: 'Booking Staff Form',
        meta: { authRequired: true },
        component: () => import('../views/pages/booking/form_staff'),
        beforeEnter: (to, from, next) => {
            const userData = localStorage.getItem('user');
            const userObject = JSON.parse(userData);
            const userType = userObject.user_type;

            // const staffId = window.sessionStorage.getItem('staff_id');
            if (userType !== 'admin' && userType !== 'staff') {
                next({ name: 'Error-404' });
            } else {
                next();
            }
        },
    },

    // Branch
    {
        path: '/branch',
        name: 'Branch',
        meta: { authRequired: true },
        component: () => import('../views/pages/branch/index'),
        beforeEnter: (to, from, next) => {
            const userData = localStorage.getItem('user');
            const userObject = JSON.parse(userData);
            const userType = userObject.user_type;

            // const staffId = window.sessionStorage.getItem('staff_id');
            if (userType !== 'admin') {
                next({ name: 'Error-404' });
            } else {
                next();
            }
        },
    },
    {
        path: '/branch/form/:id',
        name: 'Branch Form',
        meta: { authRequired: true },
        component: () => import('../views/pages/branch/form'),
        beforeEnter: (to, from, next) => {
            const userData = localStorage.getItem('user');
            const userObject = JSON.parse(userData);
            const userType = userObject.user_type;

            // const staffId = window.sessionStorage.getItem('staff_id');
            if (userType !== 'admin') {
                next({ name: 'Error-404' });
            } else {
                next();
            }
        },
    },

    // Category
    {
        path: '/category',
        name: 'Category',
        meta: { authRequired: true },
        component: () => import('../views/pages/category/index'),
        beforeEnter: (to, from, next) => {
            const userData = localStorage.getItem('user');
            const userObject = JSON.parse(userData);
            const userType = userObject.user_type;

            // const staffId = window.sessionStorage.getItem('staff_id');
            if (userType !== 'admin') {
                next({ name: 'Error-404' });
            } else {
                next();
            }
        },
    },
    {
        path: '/category/form/:id',
        name: 'Category Form',
        meta: { authRequired: true },
        component: () => import('../views/pages/category/form'),
        beforeEnter: (to, from, next) => {
            const userData = localStorage.getItem('user');
            const userObject = JSON.parse(userData);
            const userType = userObject.user_type;

            // const staffId = window.sessionStorage.getItem('staff_id');
            if (userType !== 'admin') {
                next({ name: 'Error-404' });
            } else {
                next();
            }
        },
    },

    // Timeslot Category
    {
        path: '/timeslot-category',
        name: 'Timeslot Category',
        meta: { authRequired: true },
        component: () => import('../views/pages/timeslot-category/index'),
        beforeEnter: (to, from, next) => {
            const userData = localStorage.getItem('user');
            const userObject = JSON.parse(userData);
            const userType = userObject.user_type;

            // const staffId = window.sessionStorage.getItem('staff_id');
            if (userType !== 'admin') {
                next({ name: 'Error-404' });
            } else {
                next();
            }
        },
    },
    {
        path: '/timeslot-category/form/:id',
        name: 'Timeslot Category Form',
        meta: { authRequired: true },
        component: () => import('../views/pages/timeslot-category/form'),
        beforeEnter: (to, from, next) => {
            const userData = localStorage.getItem('user');
            const userObject = JSON.parse(userData);
            const userType = userObject.user_type;

            // const staffId = window.sessionStorage.getItem('staff_id');
            if (userType !== 'admin') {
                next({ name: 'Error-404' });
            } else {
                next();
            }
        },
    },

    // Staff Redeem booking
    // {
    //     path: '/redeem',
    //     name: 'Redeem',
    //     meta: { authRequired: true },
    //     component: () => import('../views/pages/redeem/index'),
    //     beforeEnter: (to, from, next) => {
    //         // const userData = localStorage.getItem('user');
    //         // const userObject = JSON.parse(userData);
    //         // const userType = userObject.user_type;

    //         // const staffId = window.sessionStorage.getItem('staff_id');
    //         // if (userType !== 'admin') {
    //         //     next({ name: 'Error-404' });
    //         // } else {
    //             next();
    //         // }
    //     },
    // },

    // Report
    {
        path: '/report',
        name: 'Report',
        meta: { authRequired: true },
        component: () => import('../views/pages/report/index'),
        beforeEnter: (to, from, next) => {
            const userData = localStorage.getItem('user');
            const userObject = JSON.parse(userData);
            const userType = userObject.user_type;

            // const staffId = window.sessionStorage.getItem('staff_id');
            if (userType !== 'admin') {
                next({ name: 'Error-404' });
            } else {
                next();
            }
        },
    },

    // Setting - Role
    {
        path: '/setting/role',
        name: 'Role',
        meta: { authRequired: true },
        component: () => import('../views/pages/setting/role'),
        beforeEnter: (to, from, next) => {
            const userData = localStorage.getItem('user');
            const userObject = JSON.parse(userData);
            const userType = userObject.user_type;

            // const staffId = window.sessionStorage.getItem('staff_id');
            if (userType !== 'admin') {
                next({ name: 'Error-404' });
            } else {
                next();
            }
        },
    },
    {
        path: '/role/form/:id',
        name: 'Role Form',
        meta: { authRequired: true },
        component: () => import('../views/pages/setting/role_form'),
        beforeEnter: (to, from, next) => {
            const userData = localStorage.getItem('user');
            const userObject = JSON.parse(userData);
            const userType = userObject.user_type;

            // const staffId = window.sessionStorage.getItem('staff_id');
            if (userType !== 'admin') {
                next({ name: 'Error-404' });
            } else {
                next();
            }
        },
    },

    // Setting - Staff Block Date
    {
        path: '/setting/staff-block-date',
        name: 'Staff Block Date',
        meta: { authRequired: true },
        component: () => import('../views/pages/setting/staff_block_date'),
    },
    {
        path: '/setting/staff-block-date/form/:id',
        name: 'Staff Block Date Form',
        meta: { authRequired: true },
        component: () => import('../views/pages/setting/staff_block_date_form'),
        beforeEnter: (to, from, next) => {
            const userData = localStorage.getItem('user');
            const userObject = JSON.parse(userData);
            const userType = userObject.user_type;

            // const staffId = window.sessionStorage.getItem('staff_id');
            if (userType !== 'admin') {
                next({ name: 'Error-404' });
            } else {
                next();
            }
        },
    },

    // Setting - Branch Block Date
    {
        path: '/setting/branch-block-date',
        name: 'Branch Block Date',
        meta: { authRequired: true },
        component: () => import('../views/pages/setting/branch_block_date'),
        beforeEnter: (to, from, next) => {
            const userData = localStorage.getItem('user');
            const userObject = JSON.parse(userData);
            const userType = userObject.user_type;

            // const staffId = window.sessionStorage.getItem('staff_id');
            if (userType !== 'admin') {
                next({ name: 'Error-404' });
            } else {
                next();
            }
        },
    },
    {
        path: '/setting/branch-block-date/form/:id',
        name: 'Branch Block Date Form',
        meta: { authRequired: true },
        component: () => import('../views/pages/setting/branch_block_date_form'),
        beforeEnter: (to, from, next) => {
            const userData = localStorage.getItem('user');
            const userObject = JSON.parse(userData);
            const userType = userObject.user_type;

            // const staffId = window.sessionStorage.getItem('staff_id');
            if (userType !== 'admin') {
                next({ name: 'Error-404' });
            } else {
                next();
            }
        },
    },

    {
        path: '/pages/error-404',
        name: 'Error-404',
        meta: { authRequired: true },
        component: () => import('../views/pages/utility/error-404')
    },
]
